import axios from 'axios'

import { API_URL } from '../config'
import { store } from '../redux/store'

import { CLIENT_ID, CLIENT_ID_HEADER } from './clientId'
import { csrfToken } from './cookies'

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

api.interceptors.request.use(
  (config) => {
    const {
      userId,
      sessionId: storedSessionId,
      sessionToken: storedSessionToken,
    } = store.getState().auth

    if (csrfToken) {
      config.headers['X-CSRFToken'] = csrfToken
    }
    config.headers[CLIENT_ID_HEADER] = CLIENT_ID
    if (storedSessionId) {
      config.headers['X-Session-ID'] = storedSessionId
    }
    if (storedSessionToken) {
      config.headers['X-Session-Token'] = storedSessionToken
    }
    if (config.data instanceof FormData) {
      if (userId) {
        config.data.append('user_id', userId)
      }
    } else if (typeof config.data === 'object' && userId) {
      config.data = {
        ...config.data,
        user_id: userId,
      }
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

api.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    if (axios.isAxiosError(error)) {
      console.error('Axios response error:', {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        message: error.message,
        timestamp: new Date().toISOString(),
      })
    }
    return Promise.reject(error)
  },
)

export default api
